(function () {
  var SECTION_SELECTOR = '.oddit-cart-drawer';
  var CART_ENDPOINT = '/cart.js';
  var CART_ADD_ENDPOINT = '/cart/add.js';
  var CART_CHANGE_ENDPOINT = '/cart/change.js';
  // Section Rendering API name (file in /sections). Used to pull SSR HTML so we
  // can read variant inventory data — `/cart.js` does not expose it.
  var SECTION_RENDER_NAME = 'oddit-cart-drawer';

  var GWP_PROPERTY = '_gwp';

  var sectionInstances = [];
  var activeCurrency = null;
  var gwpSyncInFlight = false;
  var gwpSoldOut = false;
  var gwpAddAttempts = 0;
  var GWP_MAX_ADD_ATTEMPTS = 3;

  // ---------------------------------------------------------------------------
  // Money formatting (currency derived dynamically from session)
  // ---------------------------------------------------------------------------
  function getActiveCurrency() {
    if (activeCurrency) return activeCurrency;
    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      return window.Shopify.currency.active;
    }
    return 'USD';
  }

  function formatMoney(cents) {
    var currency = getActiveCurrency();
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ---------------------------------------------------------------------------
  // Cart AJAX API
  // ---------------------------------------------------------------------------
  function getCart() {
    return fetch(CART_ENDPOINT, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to fetch cart');
      return res.json();
    });
  }

  // Fetch the SSR'd cart drawer section so we can read each line item's
  // `inventory_quantity` / `inventory_management` data attributes (Liquid has
  // these; `/cart.js` does not). Returns `{ [lineKey]: { quantity, management } }`.
  function getLineMetaMap() {
    return fetch('/?sections=' + encodeURIComponent(SECTION_RENDER_NAME), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch section');
        return res.json();
      })
      .then(function (data) {
        var html = data && data[SECTION_RENDER_NAME];
        if (!html) return {};
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var items = doc.querySelectorAll(
          '[data-line-item][data-line-item-key]'
        );
        var map = {};
        for (var i = 0; i < items.length; i++) {
          var key = items[i].getAttribute('data-line-item-key');
          var qtyRaw = items[i].getAttribute('data-inventory-quantity');
          var mgmt = items[i].getAttribute('data-inventory-management');
          var qty = qtyRaw === '' || qtyRaw === null ? null : parseInt(qtyRaw, 10);
          map[key] = {
            quantity: isNaN(qty) ? null : qty,
            management: mgmt || null,
            gwpGift: items[i].getAttribute('data-gwp-gift') === 'true',
            gwpTrigger: items[i].getAttribute('data-gwp-trigger') === 'true'
          };
        }
        return map;
      });
  }

  function getGwpConfig() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var active = section.getAttribute('data-gwp-active');
      if (active === null) continue;

      var min = parseInt(section.getAttribute('data-gwp-min-subtotal'), 10);

      return {
        active: active === 'true',
        variantId: Number(section.getAttribute('data-gwp-variant-id')) || null,
        available: section.getAttribute('data-gwp-available') === 'true',
        minSubtotal: isNaN(min) ? 0 : min,
        label: section.getAttribute('data-gwp-label') || 'FREE GIFT'
      };
    }
    return null;
  }

  function getGwpLabel() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      var label = sections[i].getAttribute('data-gwp-label');
      if (label) return label;
    }
    return 'FREE GIFT';
  }

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties[GWP_PROPERTY]);
  }

  function syncGift(cart, gwp) {
    if (gwpSyncInFlight) return;

    var giftLine = null;
    var hasTrigger = false;
    var qualifyingSubtotal = 0;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.__gwpGift) {
        giftLine = item;
        continue;
      }
      if (item.__gwpTrigger) hasTrigger = true;
      qualifyingSubtotal += item.final_line_price;
    }

    if (giftLine) gwpAddAttempts = 0;

    var qualifies =
      gwp.active &&
      gwp.available &&
      !!gwp.variantId &&
      hasTrigger &&
      qualifyingSubtotal >= gwp.minSubtotal;

    if (qualifies && !giftLine) {
      if (gwpSoldOut || gwpAddAttempts >= GWP_MAX_ADD_ATTEMPTS) return;
      gwpSyncInFlight = true;
      gwpAddAttempts++;
      var properties = {};
      properties[GWP_PROPERTY] = 'true';
      addToCart(gwp.variantId, 1, properties)
        .catch(function (err) {
          if (err && err.status === 422) gwpSoldOut = true;
        })
        .then(function () {
          gwpSyncInFlight = false;
        });
      return;
    }

    if (!qualifies && giftLine) {
      gwpSyncInFlight = true;
      removeFromCart(giftLine.key)
        .catch(function () {})
        .then(function () {
          gwpSyncInFlight = false;
        });
      return;
    }

    if (qualifies && giftLine && giftLine.quantity !== 1) {
      gwpSyncInFlight = true;
      updateLineItemQuantity(giftLine.key, 1)
        .catch(function () {})
        .then(function () {
          gwpSyncInFlight = false;
        });
    }
  }

  function addToCart(variantId, quantity, properties) {
    if (quantity === undefined || quantity === null) quantity = 1;
    if (!properties) properties = {};

    var body = {
      id: variantId,
      quantity: quantity,
      properties: properties
    };

    return fetch(CART_ADD_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function addMultipleToCart(items) {
    return fetch(CART_ADD_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function updateLineItemQuantity(lineItemKey, quantity) {
    return fetch(CART_CHANGE_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineItemKey, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function removeFromCart(lineItemKey) {
    return updateLineItemQuantity(lineItemKey, 0);
  }

  function updateLineItemToSubscription(lineItemKey, sellingPlanId) {
    return fetch(CART_CHANGE_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        selling_plan: sellingPlanId
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function refreshCart() {
    return getCart().then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  function buildLineItemHtml(item) {
    // Resolve a line item image URL — Shopify cart objects expose `image`
    // (string URL) and sometimes `featured_image` (object). Prefer a sized
    // rendition for crisp 96px slot.
    var imageUrl = '';
    if (item.featured_image && item.featured_image.url) {
      imageUrl = item.featured_image.url;
    } else if (typeof item.image === 'string' && item.image) {
      imageUrl = item.image;
    }
    if (imageUrl) {
      imageUrl = imageUrl.replace(
        /(\.(?:jpg|jpeg|png|gif|webp|avif))(\?.*)?$/i,
        '_272x$1$2'
      );
    }

    var imageAlt =
      (item.featured_image && item.featured_image.alt) ||
      item.product_title ||
      item.title ||
      '';

    var productTitle = item.product_title || item.title || '';

    // Build "Size: US 5 / Color: Black" from options_with_values when present.
    // Falls back to the joined variant_title for older / minimal cart payloads.
    var variantParts = [];
    if (item.options_with_values && item.options_with_values.length) {
      for (var ov = 0; ov < item.options_with_values.length; ov++) {
        var opt = item.options_with_values[ov];
        if (!opt) continue;
        var optName = opt.name || '';
        var optValue = opt.value || '';
        if (optName && optValue && optValue !== 'Default Title') {
          variantParts.push(
            escapeHtml(optName) + ': ' + escapeHtml(optValue)
          );
        }
      }
    }
    if (
      variantParts.length === 0 &&
      item.variant_title &&
      item.variant_title !== 'Default Title' &&
      item.variant_title !== ''
    ) {
      variantParts.push(escapeHtml(item.variant_title));
    }

    var variantHtml = variantParts.length
      ? '<p class="oddit-cart-drawer__item-variant">' +
        variantParts.join(' / ') +
        '</p>'
      : '';

    var url = item.url || '#';
    var key = item.key;

    var isGift = isGiftLine(item);
    var isFreeGift = isGift && item.final_line_price === 0;
    var price = isFreeGift ? 'Free' : formatMoney(item.final_line_price);

    var quantityControlsHtml = [
      '      <div class="oddit-cart-drawer__quantity">',
      '        <button class="oddit-cart-drawer__quantity-btn" type="button" aria-label="Decrease quantity" data-quantity-decrease data-quantity-action="decrease" data-line-key="' +
        escapeHtml(key) +
        '" data-line-item-key="' +
        escapeHtml(key) +
        '">',
      '          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M5 12H19" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/></svg>',
      '        </button>',
      '        <span class="oddit-cart-drawer__quantity-value" data-quantity-value data-quantity-input data-line-item-key="' +
        escapeHtml(key) +
        '">' +
        escapeHtml(item.quantity) +
        '</span>',
      '        <button class="oddit-cart-drawer__quantity-btn" type="button" aria-label="Increase quantity" data-quantity-increase data-quantity-action="increase" data-line-key="' +
        escapeHtml(key) +
        '" data-line-item-key="' +
        escapeHtml(key) +
        '">',
      '          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M12 5V19" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/><path d="M5 12H19" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/></svg>',
      '        </button>',
      '      </div>',
      '      <button class="oddit-cart-drawer__item-remove" type="button" aria-label="Remove ' +
        escapeHtml(productTitle) +
        ' from cart" data-remove-item data-remove-line data-line-key="' +
        escapeHtml(key) +
        '" data-line-item-key="' +
        escapeHtml(key) +
        '">',
      '        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M3 6H21" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/><path d="M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 6L6 20C6 20.5523 6.44772 21 7 21H17C17.5523 21 18 20.5523 18 20L19 6" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 10V17" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/><path d="M14 10V17" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/></svg>',
      '      </button>'
    ].join('\n');

    var actionsInnerHtml = isGift
      ? '      <span class="oddit-cart-drawer__item-gift-badge">' +
        escapeHtml(getGwpLabel()) +
        '</span>'
      : quantityControlsHtml;

    return [
      '<div class="oddit-cart-drawer__item' +
        (isGift ? ' oddit-cart-drawer__item--gift' : '') +
        '" data-line-item data-gwp-gift="' +
        (isGift ? 'true' : 'false') +
        '" data-line-item-key="' +
        escapeHtml(key) +
        '">',
      '  <a class="oddit-cart-drawer__item-image-wrap" href="' + escapeHtml(url) + '">',
      imageUrl
        ? '    <img class="oddit-cart-drawer__item-image" src="' +
          escapeHtml(imageUrl) +
          '" alt="' +
          escapeHtml(imageAlt) +
          '" loading="lazy" width="96" height="96">'
        : '',
      '  </a>',
      '  <div class="oddit-cart-drawer__item-details">',
      '    <div class="oddit-cart-drawer__item-info-row">',
      '      <div class="oddit-cart-drawer__item-meta">',
      '        <p class="oddit-cart-drawer__item-name">',
      '          <a href="' +
        escapeHtml(url) +
        '">' +
        escapeHtml(productTitle) +
        '</a>',
      '        </p>',
      '        ' + variantHtml,
      '      </div>',
      '      <p class="oddit-cart-drawer__item-price' +
        (isFreeGift ? ' oddit-cart-drawer__item-price--free' : '') +
        '" data-line-item-price>' +
        escapeHtml(price) +
        '</p>',
      '    </div>',
      '    <div class="oddit-cart-drawer__item-actions">',
      actionsInnerHtml,
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');
  }

  function renderCart(cart) {
    if (!cart) return;

    // Cache currency so subsequent formatMoney calls reflect the shopper's
    // active session currency (markets / multi-currency stores).
    if (cart.currency) {
      activeCurrency = cart.currency;
    }

    var sections = document.querySelectorAll(SECTION_SELECTOR);

    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];

      // 1. Render line items into [data-cart-items] containers.
      //    NOTE: We deliberately do NOT setInnerHTML on the panel root or any
      //    ancestor of [data-cart-additional-checkout]. The accelerated
      //    checkout web component (shopify-accelerated-checkout-cart) must
      //    not be re-parented or removed, or wallet buttons fail to render.
      var itemsContainers = section.querySelectorAll('[data-cart-items]');
      var itemsHtml = '';
      for (var i = 0; i < cart.items.length; i++) {
        itemsHtml += buildLineItemHtml(cart.items[i]);
      }
      for (var c = 0; c < itemsContainers.length; c++) {
        itemsContainers[c].innerHTML = itemsHtml;
      }

      // 2. Update item count
      var countEls = section.querySelectorAll(
        '[data-cart-total-items], .oddit-cart-drawer__count, .oddit-cart-drawer__subtotal-count'
      );
      for (var ci = 0; ci < countEls.length; ci++) {
        countEls[ci].textContent = '(' + cart.item_count + ')';
      }

      // 3. Update subtotal
      var subtotalEls = section.querySelectorAll('[data-cart-subtotal]');
      var subtotalText = formatMoney(cart.total_price);
      for (var si = 0; si < subtotalEls.length; si++) {
        subtotalEls[si].textContent = subtotalText;
      }

      // 3b. Update checkout total label
      var checkoutTotalEls = section.querySelectorAll(
        '[data-cart-checkout-total]'
      );
      for (var cti = 0; cti < checkoutTotalEls.length; cti++) {
        checkoutTotalEls[cti].textContent = subtotalText;
      }

      // 4. Update low-stock urgency bar — initial pass with whatever inventory
      //    is already on the cart object (usually nothing; refreshUrgency below
      //    will re-run after fetching SSR'd inventory data).
      updateUrgency(cart, section);

      // 5. Toggle empty / filled state containers
      var emptyEls = section.querySelectorAll('[data-cart-empty]');
      var filledEls = section.querySelectorAll('[data-cart-filled]');
      var isEmpty = cart.item_count === 0;

      for (var ei = 0; ei < emptyEls.length; ei++) {
        if (isEmpty) {
          emptyEls[ei].removeAttribute('hidden');
        } else {
          emptyEls[ei].setAttribute('hidden', '');
        }
      }
      for (var fi = 0; fi < filledEls.length; fi++) {
        if (isEmpty) {
          filledEls[fi].setAttribute('hidden', '');
        } else {
          filledEls[fi].removeAttribute('hidden');
        }
      }

      // 5b. Generic [data-cart-state] container support (if present)
      var stateContainers = section.querySelectorAll('[data-cart-state]');
      var targetState = isEmpty ? 'empty' : 'filled';
      for (var sc = 0; sc < stateContainers.length; sc++) {
        var stateName = stateContainers[sc].getAttribute('data-cart-state');
        if (stateName === targetState) {
          stateContainers[sc].removeAttribute('hidden');
        } else {
          stateContainers[sc].setAttribute('hidden', '');
        }
      }

      // 6. Filter upsells: hide cards for products already in the cart
      var inCartProductIds = {};
      for (var ip = 0; ip < cart.items.length; ip++) {
        inCartProductIds[String(cart.items[ip].product_id)] = true;
      }
      var upsellCards = section.querySelectorAll(
        '[data-cross-sell-card][data-product-id], .oddit-cart-drawer__rec-card[data-product-id], .oddit-cart-drawer__upsell-card[data-product-id]'
      );
      for (var uc = 0; uc < upsellCards.length; uc++) {
        var pid = upsellCards[uc].getAttribute('data-product-id');
        if (pid && inCartProductIds[pid]) {
          upsellCards[uc].setAttribute('hidden', '');
        } else {
          upsellCards[uc].removeAttribute('hidden');
        }
      }
    }

    // 7. Notify other sections (header cart count badge, etc.)
    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: { cart: cart } })
    );

    // 8. Async: pull fresh inventory from Section Rendering API and re-run
    //    the urgency check. /cart.js doesn't include inventory_quantity, so
    //    this is the only way to know stock levels client-side.
    refreshUrgency(cart);
  }

  // Fetch inventory for the cart's line items and re-run updateUrgency. Fails
  // silent on network errors — the bar simply stays in whatever state the
  // initial pass left it (usually hidden).
  function refreshUrgency(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return;

    var urgencyConfigured = false;
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var s = 0; s < sections.length; s++) {
      if (sections[s].getAttribute('data-urgency-text')) {
        urgencyConfigured = true;
        break;
      }
    }

    var gwp = getGwpConfig();
    if (gwp && !gwp.active) {
      var hasGiftLine = false;
      for (var g = 0; g < cart.items.length; g++) {
        if (isGiftLine(cart.items[g])) {
          hasGiftLine = true;
          break;
        }
      }
      if (!hasGiftLine) gwp = null;
    }
    if (!urgencyConfigured && !gwp) return;

    getLineMetaMap()
      .then(function (map) {
        for (var i = 0; i < cart.items.length; i++) {
          var meta = map[cart.items[i].key];
          if (meta) {
            cart.items[i].inventory_quantity = meta.quantity;
            cart.items[i].inventory_management = meta.management;
            cart.items[i].__gwpGift = meta.gwpGift;
            cart.items[i].__gwpTrigger = meta.gwpTrigger;
          }
        }
        if (urgencyConfigured) updateUrgency(cart);
        if (gwp) syncGift(cart, gwp);
      })
      .catch(function () {
        /* leave bar in current state */
      });
  }

  // ---------------------------------------------------------------------------
  // Urgency (low-stock) bar
  //
  // Reads `data-urgency-threshold` and `data-urgency-text` from the section
  // root. Shows the bar when any line item has a tracked `inventory_quantity`
  // at or below the threshold. `[count]` in the template is replaced with the
  // lowest such quantity, wrapped in `.oddit-cart-drawer__urgency-highlight`.
  //
  // Inventory data does NOT come from /cart.js — it's hydrated by
  // refreshUrgency() via the Section Rendering API and merged onto cart.items
  // before this runs. Items without tracked inventory have a null quantity
  // and are skipped.
  // ---------------------------------------------------------------------------
  function updateUrgency(cart, scopedSection) {
    var sections = scopedSection
      ? [scopedSection]
      : document.querySelectorAll(SECTION_SELECTOR);

    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];
      var bars = section.querySelectorAll('[data-cart-urgency]');
      if (!bars.length) continue;

      var labels = section.querySelectorAll('[data-cart-urgency-text]');
      var thresholdRaw = section.getAttribute('data-urgency-threshold');
      var template = section.getAttribute('data-urgency-text') || '';
      var threshold = parseInt(thresholdRaw, 10);
      var hasItems = cart.items && cart.items.length > 0;

      if (
        !template ||
        !threshold ||
        isNaN(threshold) ||
        threshold <= 0 ||
        !hasItems
      ) {
        for (var hi = 0; hi < bars.length; hi++) {
          bars[hi].setAttribute('hidden', '');
        }
        continue;
      }

      // Find lowest tracked stock across line items.
      var lowest = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].__gwpGift || isGiftLine(cart.items[i])) continue;
        var qty = cart.items[i].inventory_quantity;
        if (typeof qty === 'number' && qty > 0) {
          if (lowest === null || qty < lowest) lowest = qty;
        }
      }

      if (lowest === null || lowest > threshold) {
        for (var hi2 = 0; hi2 < bars.length; hi2++) {
          bars[hi2].setAttribute('hidden', '');
        }
        continue;
      }

      // Escape template, swap [count] for the number, then convert any
      // [[...]] regions into an HTML-highlighted span so the merchant can
      // choose what's emphasized (e.g. "Only [[[count] left]] in stock!").
      // If no [[...]] markers are present, fall back to highlighting just the
      // count number.
      var safe = escapeHtml(template);
      var html;
      if (/\[\[[\s\S]+?\]\]/.test(safe)) {
        html = safe
          .replace(/\[count\]/g, lowest)
          .replace(/\[\[([\s\S]+?)\]\]/g, function (_, inner) {
            return (
              '<span class="oddit-cart-drawer__urgency-highlight">' +
              inner +
              '</span>'
            );
          });
      } else {
        html = safe.replace(
          /\[count\]/g,
          '<span class="oddit-cart-drawer__urgency-highlight">' +
            lowest +
            '</span>'
        );
      }

      for (var li = 0; li < labels.length; li++) {
        labels[li].innerHTML = html;
      }
      for (var bi = 0; bi < bars.length; bi++) {
        bars[bi].removeAttribute('hidden');
      }
    }
  }

  // ---------------------------------------------------------------------------
  // UI: drawer open / close, focus, scroll lock
  // ---------------------------------------------------------------------------
  function openDrawer(section) {
    if (!section) {
      section = document.querySelector(SECTION_SELECTOR);
    }
    if (!section) return;
    section.style.display = '';
    // Force a reflow so adding the open class triggers the CSS transition.
    void section.offsetWidth;
    section.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var panel = section.querySelector('.oddit-cart-drawer__panel');
    if (panel) {
      var firstFocusable = panel.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusable) {
        firstFocusable.focus();
      }
    }
  }

  function closeDrawer(section) {
    if (!section) {
      section =
        document.querySelector(SECTION_SELECTOR + '.is-open') ||
        document.querySelector(SECTION_SELECTOR);
    }
    if (!section) return;
    section.classList.remove('is-open');
    document.body.style.overflow = '';
    section.style.display = 'none';
  }

  function toggleDrawer(section) {
    if (!section) {
      section = document.querySelector(SECTION_SELECTOR);
    }
    if (!section) return;
    if (section.classList.contains('is-open')) {
      closeDrawer(section);
    } else {
      openDrawer(section);
    }
  }

  // ---------------------------------------------------------------------------
  // Carousel (cross-sell)
  // ---------------------------------------------------------------------------
  function initCarousel(section, controller) {
    var track = section.querySelector(
      '[data-cross-sell-products], .oddit-cart-drawer__upsell-track'
    );
    var dotsContainer = section.querySelector(
      '[data-cross-sell-dots], .oddit-cart-drawer__upsell-dots'
    );
    if (!track) return;

    var cards = track.querySelectorAll(
      '.oddit-cart-drawer__upsell-card, [data-cross-sell-card]'
    );

    // Generate dots if the dots container is empty.
    if (dotsContainer && dotsContainer.children.length === 0) {
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'oddit-cart-drawer__upsell-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to product ' + (i + 1));
        if (i === 0) {
          dot.classList.add('oddit-cart-drawer__upsell-dot--active');
        }
        dotsContainer.appendChild(dot);
      }
    }

    if (cards.length === 0) return;

    var dots = dotsContainer
      ? dotsContainer.querySelectorAll('.oddit-cart-drawer__upsell-dot')
      : [];

    function updateDots() {
      if (!cards.length || !dots.length) return;
      var scrollLeft = track.scrollLeft;
      var cardWidth = cards[0].offsetWidth + 8;
      var activeIndex = Math.round(scrollLeft / cardWidth);
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle(
          'oddit-cart-drawer__upsell-dot--active',
          i === activeIndex
        );
      }
    }

    track.addEventListener(
      'scroll',
      function () {
        requestAnimationFrame(updateDots);
      },
      { passive: true, signal: controller.signal }
    );

    for (var di = 0; di < dots.length; di++) {
      (function (index) {
        dots[index].addEventListener(
          'click',
          function () {
            var cardWidth = cards[0].offsetWidth + 8;
            track.scrollTo({
              left: cardWidth * index,
              behavior: 'smooth'
            });
          },
          { signal: controller.signal }
        );
      })(di);
    }

    // Drag-to-scroll on desktop. Touch devices fire touch events instead of
    // mouse events, so native horizontal scroll keeps working there. Move/up
    // listeners go on document so the drag survives the cursor leaving the
    // track.
    var isDown = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var didDrag = false;

    track.addEventListener(
      'mousedown',
      function (e) {
        isDown = true;
        didDrag = false;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      },
      { signal: controller.signal }
    );

    document.addEventListener(
      'mousemove',
      function (e) {
        if (!isDown) return;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dx) > 4) didDrag = true;
        track.scrollLeft = dragStartScroll - dx;
      },
      { signal: controller.signal }
    );

    document.addEventListener(
      'mouseup',
      function () {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      },
      { signal: controller.signal }
    );

    // Suppress click on cards if the user actually dragged.
    track.addEventListener(
      'click',
      function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      { capture: true, signal: controller.signal }
    );
  }

  // ---------------------------------------------------------------------------
  // Section init
  // ---------------------------------------------------------------------------
  function initSection(section) {
    if (!section || section.__odditCartInitialized) return;
    section.__odditCartInitialized = true;

    var controller = new AbortController();

    // Close button(s)
    var closeBtns = section.querySelectorAll(
      '[data-cart-close], .oddit-cart-drawer__close'
    );
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener(
        'click',
        function () {
          closeDrawer(section);
        },
        { signal: controller.signal }
      );
    }

    // Overlay click
    var overlay = section.querySelector(
      '[data-cart-overlay], .oddit-cart-drawer__overlay'
    );
    if (overlay) {
      overlay.addEventListener(
        'click',
        function () {
          closeDrawer(section);
        },
        { signal: controller.signal }
      );
    }

    // Escape key
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape' && section.classList.contains('is-open')) {
          closeDrawer(section);
        }
      },
      { signal: controller.signal }
    );

    // Focus trap inside the panel while open
    section.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Tab') return;
        if (!section.classList.contains('is-open')) return;
        var panel = section.querySelector('.oddit-cart-drawer__panel');
        if (!panel) return;
        var focusables = panel.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      },
      { signal: controller.signal }
    );

    // Carousel
    initCarousel(section, controller);

    // ---- Quantity & remove buttons (event delegation on the items list) ----
    var itemsRoot = section.querySelector('[data-cart-items]');
    if (itemsRoot) {
      itemsRoot.addEventListener(
        'click',
        function (e) {
          var target = e.target;
          if (!target || target.nodeType !== 1) return;

          // Quantity decrease / increase
          var qtyBtn = target.closest(
            '[data-quantity-decrease], [data-quantity-increase], [data-quantity-action]'
          );
          if (qtyBtn && itemsRoot.contains(qtyBtn)) {
            var key =
              qtyBtn.getAttribute('data-line-key') ||
              qtyBtn.getAttribute('data-line-item-key');
            if (!key) return;

            var line = qtyBtn.closest('[data-line-item]');
            var valueEl = line
              ? line.querySelector(
                  '[data-quantity-value], [data-quantity-input]'
                )
              : null;
            var current = valueEl
              ? parseInt(valueEl.textContent, 10) || 1
              : 1;

            var action = qtyBtn.getAttribute('data-quantity-action');
            var isDecrease =
              action === 'decrease' ||
              qtyBtn.hasAttribute('data-quantity-decrease') ||
              qtyBtn.getAttribute('aria-label') === 'Decrease quantity';

            var nextQty = isDecrease
              ? Math.max(current - 1, 0)
              : current + 1;

            qtyBtn.disabled = true;
            updateLineItemQuantity(key, nextQty)
              .catch(function () {
                /* silently ignore — Liquid render stays in place */
              })
              .then(function () {
                qtyBtn.disabled = false;
              });
            return;
          }

          // Remove
          var removeBtn = target.closest(
            '[data-remove-item], [data-remove-line]'
          );
          if (removeBtn && itemsRoot.contains(removeBtn)) {
            var rkey =
              removeBtn.getAttribute('data-line-key') ||
              removeBtn.getAttribute('data-line-item-key');
            if (!rkey) return;
            removeBtn.disabled = true;
            removeFromCart(rkey)
              .catch(function () {})
              .then(function () {
                removeBtn.disabled = false;
              });
            return;
          }
        },
        { signal: controller.signal }
      );
    }

    // ---- Cross-sell / upsell add buttons ----
    var addBtnSelector = [
      '[data-add-to-cart][data-variant-id]',
      '.oddit-cart-drawer__rec-add[data-variant-id]',
      '.oddit-cart-drawer__upsell-add[data-variant-id]',
      '.oddit-cart-drawer__upsell-cta[data-variant-id]'
    ].join(', ');

    var addBtns = section.querySelectorAll(addBtnSelector);
    for (var ab = 0; ab < addBtns.length; ab++) {
      (function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var variantId = Number(btn.getAttribute('data-variant-id'));
            if (!variantId) return;
            btn.disabled = true;
            addToCart(variantId, 1)
              .catch(function () {})
              .then(function () {
                btn.disabled = false;
              });
          },
          { signal: controller.signal }
        );
      })(addBtns[ab]);
    }

    // ---- Subscription switch CTA ----
    // Applies the selling plan to every line item that doesn't already have
    // one. Mirrors the typical "Switch to subscription" upsell pattern.
    var switchBtns = section.querySelectorAll(
      '.oddit-cart-drawer__switch-cta[data-selling-plan-id]'
    );
    for (var sb = 0; sb < switchBtns.length; sb++) {
      (function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var sellingPlanId = btn.getAttribute('data-selling-plan-id');
            if (!sellingPlanId) return;
            btn.disabled = true;

            getCart()
              .then(function (cart) {
                var promises = [];
                for (var i = 0; i < cart.items.length; i++) {
                  var line = cart.items[i];
                  if (!line.selling_plan_allocation) {
                    promises.push(
                      updateLineItemToSubscription(line.key, sellingPlanId)
                    );
                  }
                }
                if (promises.length === 0) return cart;
                return Promise.all(promises).then(function () {
                  return getCart();
                });
              })
              .then(function (cart) {
                renderCart(cart);
              })
              .catch(function () {})
              .then(function () {
                btn.disabled = false;
              });
          },
          { signal: controller.signal }
        );
      })(switchBtns[sb]);
    }

    // ---- Checkout button ----
    var checkoutBtns = section.querySelectorAll(
      '[data-cart-checkout], .oddit-cart-drawer__checkout-cta'
    );
    for (var co = 0; co < checkoutBtns.length; co++) {
      checkoutBtns[co].addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          window.location.href = '/checkout';
        },
        { signal: controller.signal }
      );
    }

    // ---- Hydrate from /cart.js so the drawer matches the live cart state ----
    refreshCart().catch(function () {
      /* offline / network — leave Liquid-rendered state in place */
    });

    sectionInstances.push({ section: section, controller: controller });
  }

  function destroySection(section) {
    for (var i = sectionInstances.length - 1; i >= 0; i--) {
      if (sectionInstances[i].section === section) {
        sectionInstances[i].controller.abort();
        sectionInstances.splice(i, 1);
      }
    }
    if (section) {
      section.__odditCartInitialized = false;
    }
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor compatibility
  document.addEventListener('shopify:section:load', function (e) {
    var section =
      e.target && e.target.querySelector
        ? e.target.querySelector(SECTION_SELECTOR)
        : null;
    if (section) initSection(section);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var section =
      e.target && e.target.querySelector
        ? e.target.querySelector(SECTION_SELECTOR)
        : null;
    if (section) destroySection(section);
  });

  // ---------------------------------------------------------------------------
  // Public API — exposed as window.OdditCartDrawer (PascalCase).
  // Other sections (header cart icon, PDP add-to-cart) call into this API.
  // ---------------------------------------------------------------------------
  window.OdditCartDrawer = {
    open: function () {
      openDrawer();
    },
    close: function () {
      closeDrawer();
    },
    toggle: function () {
      toggleDrawer();
    },
    addToCart: function (variantId, quantity, properties) {
      return addToCart(variantId, quantity, properties).then(function (cart) {
        openDrawer();
        return cart;
      });
    },
    addMultipleToCart: function (items) {
      return addMultipleToCart(items).then(function (cart) {
        openDrawer();
        return cart;
      });
    },
    removeFromCart: removeFromCart,
    updateLineItemQuantity: updateLineItemQuantity,
    updateLineItemToSubscription: updateLineItemToSubscription,
    getCart: getCart,
    refreshCart: refreshCart
  };

  // Backwards-compat alias for any legacy camelCase references.
  window.odditCartDrawer = window.OdditCartDrawer;
})();
